'use strict';
import Vue from 'vue'
export default {
    test() {
        console.log("公共方法")
    },
    
    isParents(obj: any, parentObj: any) {
        while (
            obj != undefined &&
            obj != null &&
            obj.tagName.toUpperCase() != "BODY"
        ) {
            if (obj == parentObj) {
                return true;
            }
            obj = obj.parentNode;
        }
        return false;
    }
}